import i18n from "../../../i18n";

import ModeEditOutlineOutlined from "@mui/icons-material/ModeEditOutlineOutlined";

import DateService from "../../../services/dateService";
import SelectFieldService from "../../../services/selectFieldService";

export const EQUIPMENT_INSTALATION_TENANT_SET_TABLE_CONFIG = [
  {
    name: "tenant",
    getValueCallback: (rowData) => rowData.tenant,
    label: i18n.t("table.counter_repository.tenant"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "ppe",
    getValueCallback: (rowData) => rowData.ppe,
    label: i18n.t("table.ppe_table.ppe_number"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "electricity_tariff_group",
    getValueCallback: (rowData) => rowData.electricity_tariff_group,
    label: i18n.t("table.electricity_tariff_table.electricity_tariff_group"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "eits_power",
    getValueCallback: (rowData) => rowData.eits_power,
    label: i18n.t("form.meter_passport.eits_power"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "eits_start_settlement",
    getValueCallback: (rowData) =>
      DateService.convertDatetimeFromBackendToFormatYYYYMMDD(
        rowData.eits_start_settlement
      ),
    label: i18n.t("table.counter_repository.eits_start_settlement"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "eits_end_settlement",
    getValueCallback: (rowData) =>
      DateService.convertDatetimeFromBackendToFormatYYYYMMDD(
        rowData.eits_end_settlement
      ),
    label: i18n.t("table.counter_repository.eits_end_settlement"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "eits_active",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(rowData.eits_active),
    label: i18n.t("table.counter_repository.eits_active"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "eits_parent",
    getValueCallback: (rowData) => rowData.eits_parent,
    label: i18n.t("table.counter_repository.eits_parent"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "edit",
    getValueCallback: (rowData, onClickMultipleLocationAlert, onClickEdit) => (
      <ModeEditOutlineOutlined onClick={(e) => onClickEdit(rowData.id)} />
    ),
    label: i18n.t("edit"),
    filterType: null,
    headerSx: { whiteSpace: "break-spaces" },
    getFilterFieldConfigCallback: (filteringData) => undefined,
    allowChangeVisibility: false,
    excludedFromExport: true,
  },
];
